import apiHybris from '~/services/apiHybris';

export async function sendResetPasswordEmailUseCase(
  email: string
): Promise<boolean> {
  try {
    const response = await apiHybris.post(`users/${email}/emailpassword`, {
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    });

    return response.status === 200;
  } catch (err: any) {
    throw {
      message:
        err.response.data.errors[0].message ??
        'Um erro ocorreu durante a solicitação. Por favor, tente novamente mais tarde.',
    };
  }
}
